import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import { useLogin } from 'hooks';

export function ResetPasswordPage() {
  const { t } = useTranslation('auth');
  const { onResetPasswordEmailOpen } = useLogin();
  const { enqueueSnackbar } = useSnackbar();

  const search = useLocation().search;
  const navigate = useNavigate();

  useEffect(() => {
    const userId = new URLSearchParams(search).get('userId');
    const token = new URLSearchParams(search).get('token')?.replaceAll(' ', '+');
    const phone = new URLSearchParams(search).get('phone')?.replace('$ ', '+');

    if (userId && token) {
      onResetPasswordEmailOpen(userId, token, phone ?? '');
      navigate('../login');
    } else {
      enqueueSnackbar(t('invalidResetPasswordLink'), { variant: 'error' });
    }
  }, [search]);

  return <></>;
}
